import { __decorate } from "tslib";
import lang from '@blade-sxp/portrait-management/lang/index';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
    value;
    placeholder;
    maxlength;
    defaultAutoSubmitTimeoutId = 200;
    selfValueTimeoutId = 0;
    // 用于爷孙双向绑定
    get selfValue() {
        return this.value;
    }
    set selfValue(val) {
        this.$emit('update:value', val);
    }
    selfValueChange(val) {
        clearTimeout(this.selfValueTimeoutId);
        this.selfValueTimeoutId = +setTimeout(() => {
            this.handleEnter();
        }, this.defaultAutoSubmitTimeoutId);
    }
    handleEnter() {
        this.$emit('find', { value: this.selfValue });
        clearTimeout(this.selfValueTimeoutId);
    }
};
__decorate([
    Prop()
], default_1.prototype, "value", void 0);
__decorate([
    Prop()
], default_1.prototype, "placeholder", void 0);
__decorate([
    Prop({ default: 50 })
], default_1.prototype, "maxlength", void 0);
__decorate([
    Watch('selfValue')
], default_1.prototype, "selfValueChange", null);
default_1 = __decorate([
    Component({
        i18n: {
            messages: lang,
        },
    })
], default_1);
export default default_1;
